export const parentNavigate = (path, state = {}) => {
  window.parent.postMessage(
    {
      action: "navigateToHome",
      url: path,
      state,
    },
    "*"
  );
};

